import { SkinId } from "../../types";
import { body1TypographyMixin, body2TypographyMixin, body3TypographyMixin, body4TypographyMixin, body5TypographyMixin, tagTypographyMixin, eyebrowTypographyMixin, labelTypographyMixin, textLinkTypographyMixin, display1TypographyMixin, display2TypographyMixin, display3TypographyMixin, display4TypographyMixin, display5TypographyMixin, display6TypographyMixin, display7TypographyMixin, display8TypographyMixin, display9TypographyMixin, ctaTypographyMixin, } from "../mixins/typography";
import { rgProductBaseIcons, rgProductsBaseTheme } from "../../rg-product-pages/chromas/base";
import { mediaQueries } from "../../shared/mixins/breakpoints";
import { DEFAULT_BREAKPOINTS } from "../../../functional/breakpointUtils";
import arrowLeft from "../assets/arrow-left.svg";
import arrowRight from "../assets/arrow-right.svg";
import carouselLeft from "../assets/carousel-left.svg";
import carouselRight from "../assets/carousel-right.svg";
import playerContrast from "../assets/player-contrast.svg";
import tint from "polished/lib/color/tint";
import shade from "polished/lib/color/shade";
const projectLIcons = {
    ...rgProductBaseIcons,
    arrowLeft,
    arrowRight,
    carouselLeft,
    carouselRight,
    player: playerContrast,
};
const brandColors = {
    primary: "#CDF564",
    dark1: "#1B1D1F",
    light1: "#F1F2F1",
    test: "#FF00FF",
    notDefined: "#FF00FF",
};
const palette1 = {
    accents1: brandColors.dark1,
    accents1_hover: tint(0.2, brandColors.dark1),
    accents1_disabled: tint(0.8, brandColors.dark1),
    accents2: brandColors.dark1,
    accents2_hover: tint(0.2, brandColors.dark1),
    accents2_disabled: tint(0.8, brandColors.dark1),
    bladetext1: brandColors.dark1,
    bladetext1_light: tint(0.4, brandColors.dark1),
    bladebg1: brandColors.light1,
    bladetext2: brandColors.dark1,
    bladebg2: shade(0.2, brandColors.light1),
    bladetext3: brandColors.dark1,
    bladebg3: brandColors.primary,
    bladebg3_hover: tint(0.2, brandColors.primary),
    bladebg3_disabled: tint(0.2, brandColors.primary),
    bladetext_ulc: brandColors.light1,
    underlay: brandColors.dark1,
    keyline: shade(0.2, brandColors.light1),
    ctatext1: brandColors.light1,
    ctatext1_hover: brandColors.dark1,
    ctatext1_disabled: tint(0.6, brandColors.dark1),
    ctabg1: brandColors.dark1,
    ctabg1_hover: brandColors.primary,
    ctabg1_disabled: tint(0.8, brandColors.dark1),
    ctastroke1: brandColors.dark1,
    ctastroke1_hover: brandColors.primary,
    ctastroke1_disabled: tint(0.8, brandColors.dark1),
    ctatext2: brandColors.dark1,
    ctatext2_hover: brandColors.dark1,
    ctatext2_disabled: tint(0.6, brandColors.dark1),
    ctabg2: brandColors.light1,
    ctabg2_hover: brandColors.primary,
    ctabg2_disabled: brandColors.light1,
    ctastroke2: brandColors.dark1,
    ctastroke2_hover: brandColors.primary,
    ctastroke2_disabled: tint(0.6, brandColors.dark1),
};
const palette2 = {
    accents1: brandColors.primary,
    accents1_hover: tint(0.2, brandColors.primary),
    accents1_disabled: shade(0.2, brandColors.primary),
    accents2: brandColors.light1,
    accents2_disabled: tint(0.2, brandColors.dark1),
    accents2_hover: tint(0.2, brandColors.light1),
    bladetext1: brandColors.light1,
    bladetext1_light: shade(0.4, brandColors.light1),
    bladebg1: brandColors.dark1,
    bladetext2: brandColors.primary,
    bladebg2: tint(0.2, brandColors.dark1),
    bladetext3: brandColors.dark1,
    bladebg3: brandColors.primary,
    bladebg3_hover: shade(0.2, brandColors.primary),
    bladebg3_disabled: shade(0.2, brandColors.primary),
    bladetext_ulc: brandColors.light1,
    underlay: brandColors.dark1,
    keyline: tint(0.2, brandColors.dark1),
    ctatext1: brandColors.dark1,
    ctatext1_hover: brandColors.dark1,
    ctatext1_disabled: tint(0.2, brandColors.dark1),
    ctabg1: brandColors.light1,
    ctabg1_hover: brandColors.primary,
    ctabg1_disabled: tint(0.1, brandColors.dark1),
    ctastroke1: brandColors.light1,
    ctastroke1_hover: brandColors.primary,
    ctastroke1_disabled: tint(0.1, brandColors.dark1),
    ctatext2: brandColors.light1,
    ctatext2_hover: brandColors.dark1,
    ctatext2_disabled: tint(0.2, brandColors.dark1),
    ctabg2: brandColors.dark1,
    ctabg2_hover: brandColors.primary,
    ctabg2_disabled: brandColors.dark1,
    ctastroke2: brandColors.light1,
    ctastroke2_hover: brandColors.primary,
    ctastroke2_disabled: tint(0.2, brandColors.dark1),
};
const palette3 = {
    accents1: brandColors.dark1,
    accents1_hover: tint(0.2, brandColors.dark1),
    accents1_disabled: shade(0.2, brandColors.primary),
    accents2: brandColors.light1,
    accents2_hover: tint(0.2, brandColors.light1),
    accents2_disabled: shade(0.2, brandColors.primary),
    bladetext1: brandColors.dark1,
    bladetext1_light: tint(0.1, brandColors.dark1),
    bladebg1: brandColors.primary,
    bladetext2: brandColors.dark1,
    bladebg2: shade(0.2, brandColors.primary),
    bladetext3: brandColors.primary,
    bladebg3: brandColors.dark1,
    bladebg3_hover: tint(0.2, brandColors.dark1),
    bladebg3_disabled: tint(0.2, brandColors.dark1),
    bladetext_ulc: brandColors.light1,
    underlay: brandColors.dark1,
    keyline: shade(0.2, brandColors.primary),
    ctatext1: brandColors.light1,
    ctatext1_hover: brandColors.dark1,
    ctatext1_disabled: shade(0.2, brandColors.primary),
    ctabg1: brandColors.dark1,
    ctabg1_hover: brandColors.primary,
    ctabg1_disabled: tint(0.2, brandColors.primary),
    ctastroke1: brandColors.dark1,
    ctastroke1_hover: brandColors.dark1,
    ctastroke1_disabled: tint(0.2, brandColors.primary),
    ctatext2: brandColors.dark1,
    ctatext2_hover: brandColors.dark1,
    ctatext2_disabled: shade(0.2, brandColors.primary),
    ctabg2: brandColors.light1,
    ctabg2_hover: brandColors.primary,
    ctabg2_disabled: brandColors.primary,
    ctastroke2: brandColors.dark1,
    ctastroke2_hover: brandColors.dark1,
    ctastroke2_disabled: shade(0.2, brandColors.primary),
};
export const riotProductLionBaseChroma = {
    ...rgProductsBaseTheme,
    skinId: SkinId.RiotProductLion,
    parentSkinId: SkinId.RiotProduct,
    palettes: {
        palette1,
        palette2,
        palette3,
    },
    palette: {
        primary: "#CDF564",
        secondary: "#F56764",
        tertiary: "#FF00FF",
        quaternary: "#FF00FF",
        background: "#1B1D1F",
        foreground: "#F1F5F0",
        secondaryBackground: "#1B1D1F",
        secondaryForeground: "#F1F5F0",
        tertiaryBackground: "#2A2D30",
        tertiaryForeground: "#F1F5F0",
        error: "#ff0000",
        focus: "#6164CD",
    },
    cssImports: [
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/shapiro.css",
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/mplus1p.css",
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/blackhansans.css",
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/rixsgo.css",
    ],
    DEFAULT_BREAKPOINTS,
    mediaQueries,
    typography: {
        ...rgProductsBaseTheme.typography,
        body1: body1TypographyMixin,
        body2: body2TypographyMixin,
        body3: body3TypographyMixin,
        body4: body4TypographyMixin,
        body5: body5TypographyMixin,
        display1: display1TypographyMixin,
        display2: display2TypographyMixin,
        display3: display3TypographyMixin,
        display4: display4TypographyMixin,
        display5: display5TypographyMixin,
        display6: display6TypographyMixin,
        display7: display7TypographyMixin,
        display8: display8TypographyMixin,
        display9: display9TypographyMixin,
        tag: tagTypographyMixin,
        eyebrow: eyebrowTypographyMixin,
        label: labelTypographyMixin,
        textLink: textLinkTypographyMixin,
        cta: ctaTypographyMixin,
    },
    input: {
        background: "transparent",
        border: "#F1F5F0",
        foreground: "#F1F5F0",
        backgroundFocus: "transparent",
        borderFocus: "#FFF",
        foregroundFocus: "#FFF",
        backgroundChecked: "#F0F0F0",
        borderChecked: "#141414",
        foregroundChecked: "#141414",
        backgroundDisabled: "#787878",
        borderDisabled: "#303030",
        foregroundDisabled: "#303030",
        backgroundValid: "transparent",
        borderValid: "#F1F5F0",
        foregroundValid: "#F1F5F0",
        backgroundInvalid: "transparent",
        borderInvalid: "#EB0029",
        foregroundInvalid: "#F1F5F0",
        placeholder: "#343536",
    },
    components: {
        ...rgProductsBaseTheme.components,
        ctaBackground: "#1B1D1F",
        ctaForeground: "#CDF564",
    },
    icons: projectLIcons,
};
//# sourceMappingURL=base.js.map